import * as React from 'react';
import {TextInput} from '../reusableComponents/FormComponents/TextInput';
import {Icon} from '../reusableComponents/Icon';
import {PerfectScrollbar} from '../reusableComponents/PerfectScrollbar';

export interface IInstructionsTableProps {
    defaultValue?: string;
}

export interface IInstructionsTableState {
    instruction: string;
    instructions: string[];
    isEdit: boolean;
    activeIndex: number;
}

export class InstructionsTable extends React.Component<IInstructionsTableProps, IInstructionsTableState> {
    constructor(props: IInstructionsTableProps) {
        super(props);
        
        let initialInstructions = [];
        if (props.defaultValue) {
            try {
                // Check if it's already a JSON array, otherwise split by <hr/> or treat as single string
                initialInstructions = JSON.parse(props.defaultValue);
                if (!Array.isArray(initialInstructions)) {
                    initialInstructions = [props.defaultValue];
                }
            } catch (e) {
                // Not JSON, try splitting if we use a specific delimiter, else just one item
                initialInstructions = props.defaultValue ? [props.defaultValue] : [];
            }
        }

        this.state = {
            instruction: '',
            instructions: initialInstructions, 
            isEdit: false, 
            activeIndex: null
        };
    }

    get instructionsString() {
        return JSON.stringify(this.state.instructions);
    }

    public saveInstruction = () => {
        if (!this.state.instruction.trim()) {
            return;
        }
        if (this.state.isEdit && this.state.activeIndex !== null) {
            const filteredInstructions = [...this.state.instructions];
            filteredInstructions[this.state.activeIndex] = this.state.instruction.trim();
            this.setState({
                instructions: filteredInstructions,
                instruction: '',
                isEdit: false,
                activeIndex: null
            });
            return;
        }
        const allInstructions = [...this.state.instructions];
        allInstructions.push(this.state.instruction.trim());
        this.setState({
            instructions: allInstructions,
            instruction: ''
        });
    }

    public handleInstructionEdit = (index) => {
        this.setState({
            instruction: this.state.instructions[index],
            isEdit: true,
            activeIndex: index
        });
    }

    public handleInstructionDelete = (index) => {
        const filteredInstructions = this.state.instructions.filter((inst, i) => index !== i);
        this.setState({
            instructions: filteredInstructions,
            instruction: '',
            isEdit: false,
            activeIndex: null
        });
    }

    public renderInstructions = () => {
        return this.state.instructions.length > 0 ? this.state.instructions.map((inst, index) => {
            return <InstructionRow
                key={index}
                handleEdit={this.handleInstructionEdit}
                handleDelete={this.handleInstructionDelete}
                index={index}
                instNum={index + 1}
                inst={inst}
            />;
        }) : <span style={{color: 'white', padding: '10px'}}>No Instructions Added</span>;
    }

    public render() {
        return <div className="question-table" style={{marginTop: '20px'}}>
            <div className="title">Instructions:</div>
            <div className="table-head">
                <div className="editable">
                    Edit/Delete
                </div>
                <div className="ques number">
                    #
                </div>
                <div className="ques question" style={{ width: '68%' }}>
                    Instruction
                </div>
            </div>
            <PerfectScrollbar className="questions">
                {this.renderInstructions()}
            </PerfectScrollbar>
            <div className="question-input">
                <div className="question" style={{flex: 9}}>
                    <div className="head" style={{color: 'white'}}>Instruction:</div>
                    <textarea
                        id="moduleInstructions"
                        onChange={(e) => this.setState({
                            instruction: e.target.value
                        })}
                        value={this.state.instruction}
                        style={{
                            width: '100%',
                            minHeight: '150px',
                            backgroundColor: 'white',
                            color: 'black',
                            padding: '10px',
                            fontSize: '16px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            resize: 'vertical',
                            boxSizing: 'border-box'
                        }}
                    />
                </div>
                
                <div className="add-answer" onClick={this.saveInstruction} style={{flex: 1, cursor: 'pointer', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                    <div><Icon icon="plus"/></div>
                    <div><label style={{cursor: 'pointer'}}>{this.state.isEdit ? 'Update' : 'Add'}</label></div>
                </div>
            </div>
        </div>;
    }
}

const InstructionRow = ({instNum, inst, index, handleEdit, handleDelete}) => {
    return <div className="ques-row">
        <div className="options">
            <Icon icon="edit" onClick={() => handleEdit(index)} />
            <Icon icon="trash" onClick={() => handleDelete(index)} />
        </div>
        <div className="que-num">{instNum}</div>
        <div className="question" style={{ width: '68%', whiteSpace: 'pre-wrap' }}>{inst}</div>
    </div>;
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/InstructionsTable.tsx